var FormalizeCompany = /** @class */ (function () {
    function FormalizeCompany(companyId, companyName, clientOrBUId, clientOrBUName) {
        this.companyId = companyId;
        this.companyName = companyName;
        this.clientOrBUId = clientOrBUId;
        this.clientOrBUName = clientOrBUName;
    }
    return FormalizeCompany;
}());
export { FormalizeCompany };
var FormalizeJobMatch = /** @class */ (function () {
    function FormalizeJobMatch(jobMatchId, jobId, requisitionId, requisitionName) {
        this.jobMatchId = jobMatchId;
        this.jobId = jobId;
        this.requisitionId = requisitionId;
        this.requisitionName = requisitionName;
    }
    return FormalizeJobMatch;
}());
export { FormalizeJobMatch };
var FormalizeRequisition = /** @class */ (function () {
    function FormalizeRequisition(jobId, requisitionId, requisitionName) {
        this.jobId = jobId;
        this.requisitionId = requisitionId;
        this.requisitionName = requisitionName;
    }
    return FormalizeRequisition;
}());
export { FormalizeRequisition };
var FormalizeCandidate = /** @class */ (function () {
    function FormalizeCandidate(candidateId, firstName, lastName) {
        this.candidateId = candidateId;
        this.firstName = firstName;
        this.lastName = lastName;
    }
    return FormalizeCandidate;
}());
export { FormalizeCandidate };
var FormalizeUser = /** @class */ (function () {
    function FormalizeUser(userId, firstName, lastName, email) {
        this.userId = userId;
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
    }
    return FormalizeUser;
}());
export { FormalizeUser };
var FormalizePayload = /** @class */ (function () {
    function FormalizePayload(data) {
        this.activityType = 'TEXT_FORMALIZATION';
        this.duration = null;
        this.dateRange = { startDate: null, endDate: null };
        this.sourceScreen = null;
        this.externalNote = null;
        this.noteId = null;
        this.company = null;
        this.jobMatch = null;
        this.requisition = null;
        this.candidate = null;
        this.user = null;
        this.originalText = null;
        this.formalizedText = null;
        this.mode = 'TEXT';
        this.tone = null;
        this.savedNote = null;
        if (data)
            Object.assign(this, data);
    }
    return FormalizePayload;
}());
export { FormalizePayload };
//# sourceMappingURL=formalizePayload.js.map